import { __assign as i, __extends as r } from "./index11.js";
var u = function(e) {
  var t = {
    gauge: "g",
    counter: "c"
  };
  return t[e];
}, c = (
  /** @class */
  function() {
    function e() {
      this.metrics = [];
    }
    return e.prototype.increment = function(t, n, o) {
      n === void 0 && (n = 1), this.metrics.push({
        metric: t,
        value: n,
        tags: o ?? [],
        type: "counter",
        timestamp: Date.now()
      });
    }, e.prototype.gauge = function(t, n, o) {
      this.metrics.push({
        metric: t,
        value: n,
        tags: o ?? [],
        type: "gauge",
        timestamp: Date.now()
      });
    }, e.prototype.flush = function() {
      var t = this.metrics.map(function(n) {
        return i(i({}, n), { tags: n.tags.join(",") });
      });
      console.table ? console.table(t) : console.log(t), this.metrics = [];
    }, e.prototype.serialize = function() {
      return this.metrics.map(function(t) {
        return {
          m: t.metric,
          v: t.value,
          t: t.tags,
          k: u(t.type),
          e: t.timestamp
        };
      });
    }, e;
  }()
), a = (
  /** @class */
  function(e) {
    r(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.gauge = function() {
    }, t.prototype.increment = function() {
    }, t.prototype.flush = function() {
    }, t.prototype.serialize = function() {
      return [];
    }, t;
  }(c)
);
export {
  c as CoreStats,
  a as NullStats
};
//# sourceMappingURL=index58.js.map
